import { render, staticRenderFns } from "./PackageUiCategory.vue?vue&type=template&id=10e1434e&scoped=true"
import script from "./PackageUiCategory.vue?vue&type=script&lang=js"
export * from "./PackageUiCategory.vue?vue&type=script&lang=js"
import style0 from "./PackageUiCategory.vue?vue&type=style&index=0&id=10e1434e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e1434e",
  null
  
)

export default component.exports